/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OpenTo {
    DATES = 'DATES',
    RELATIONSHIP = 'RELATIONSHIP',
    TRAVEL_TOGETHER = 'TRAVEL_TOGETHER',
}
